export default __webpack_public_path__ + "static/media/cardfronttr.8c53e2b0.png";